import i18n from '_/i18n';

export default {
    name: 'UuidField',
    
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        id: {
            type: [Number, String],
            required: true
        },
        name: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: () => i18n.t('uuid.autoGeneratedUuid')
        },
        helpText: {
            type: String,
            default: () => i18n.t('uuid.autoGeneratedHelpText')
        },
        errorMessage: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            displayValue: this.value,
            hasError: false,
            copyButtonTitle: i18n.t('uuid.copyToClipboard'),
            copyButtonTimeout: null
        };
    },

    computed: {
        // Add any computed properties here if needed
    },

    watch: {
        value(newVal) {
            this.displayValue = newVal;
        },
        errorMessage(newVal) {
            this.hasError = !!newVal;
        }
    },

    beforeDestroy() {
        // Clear any pending timeouts when component is destroyed
        if (this.copyButtonTimeout) {
            clearTimeout(this.copyButtonTimeout);
        }
    },

    created() {
        // If no value is provided, emit an empty string to trigger generation
        if (!this.value) {
            this.$emit('input', '');
        }
    },

    methods: {
        addNotification(payload) {
            return this.$store.dispatch('notification/addNotification', payload);
        },
        validate() {
            // Always valid since it's auto-generated
            return true;
        },
        
        focus() {
            // No-op since the field is read-only
        },
        
        /**
         * Copies the UUID to the clipboard
         */
        copyToClipboard() {
            if (!this.displayValue) return;
            
            // Create a temporary input element
            const tempInput = document.createElement('input');
            tempInput.value = this.displayValue;
            document.body.appendChild(tempInput);
            
            // Select and copy the text
            tempInput.select();
            document.execCommand('copy');
            
            // Clean up
            document.body.removeChild(tempInput);
            
            // Update button state to show success
            this.copyButtonTitle = i18n.t('uuid.copied');
            
            // Show notification
            this.addNotification({
                notification: {
                    compiled_message: i18n.t('uuid.uuidCopiedToClipboard'),
                    type: 'success',
                    delay: 2000,
                    icon: 'fal fa-check-circle',
                }
            });

            // Reset button state after 2 seconds
            if (this.copyButtonTimeout) {
                clearTimeout(this.copyButtonTimeout);
            }
            
            this.copyButtonTimeout = setTimeout(() => {
                this.copyButtonTitle = i18n.t('uuid.copyToClipboard');
                this.copyButtonTimeout = null;
            }, 2000);
        }
    }
};
